
    // Declare APP_COMMIT as a global variable in app for version checks using the commit hash
    window.APP_COMMIT = "1cacf7a";
    const timestamp = Date.now();
    setTimeout(() => {
      const hasErrorBoundary = document.getElementById("error-boundary") !== null;
      const isPageBlank = document.querySelector(".ant-app") === null;

      if (isPageBlank && !hasErrorBoundary) {
        // Log pour Splunk (ne sera pas annulé par le reload)
        navigator.sendBeacon(`/favicon.ico?timestamp=${timestamp}`);
        window.location.href = "/";
      }
    }, 8000);
    fetch("/deployment_info.json?no-cache=" + timestamp)
      .then(res => {
        if (!res.ok) {
          return null;
        } 
        return res.json();
      })
      .then(data => {
        // Ensure there is a valid commit (not empty and not the GitLab placeholder "$CI_COMMIT_SHA" in DEV)
        if (!data || !data.COMMIT || data.COMMIT.startsWith("$")) {
          return;
        }
        if (data.COMMIT !== window.APP_COMMIT) {
          fetch(`/favicon.ico?ts=${Date.now()}&old=${window.APP_COMMIT}&new=${data.COMMIT}`).catch(() => {});
        }
      })
      .catch(() => {});
  